import { Switch, useRouteMatch } from "react-router-dom";

import AuthRoute from "@/components/AuthRoute";

import OrdersAndTests from "./OrdersAndTests";
import Test from "./Test";

export default function CustomerTestResults() {
  const match = useRouteMatch();

  return (
    <Switch>
      <AuthRoute exact path={match.path} component={OrdersAndTests} />
      <AuthRoute path={`${match.path}/:userTestId`} component={Test} />
    </Switch>
  );
}
